<template>
    <div v-if="subFormAvailable">
        <b-row class="d-flex align-items-center">
            <h2>
                Fahrzeug
            </h2>
            <b-button
                class="klippa-subform-toggle-btn"
                variant="primary"
                @click="toggleAll">
                {{ someIncluded ? 'Alle abwählen' : 'Alle auswählen' }}
            </b-button>
        </b-row>
        <b-row>
            <b-col>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldVin"
                        class="col-12"
                        :form-context="formContext"
                        label="VIN"
                        property="vin"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldLicensePlate"
                        class="col-12"
                        :form-context="formContext"
                        label="Kennzeichen"
                        property="licensePlate"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldModel"
                        class="col-12"
                        :form-context="formContext"
                        label="Modell"
                        property="model"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldHsn"
                        class="col-12"
                        :form-context="formContext"
                        label="HSN"
                        property="hsn"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldTsn"
                        class="col-12"
                        :form-context="formContext"
                        label="TSN"
                        property="tsn"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldMileage"
                        class="col-12"
                        :form-context="formContext"
                        label="Kilometerstand"
                        property="mileage"
                        :subform-identifier="subformIdentifier"
                        type="number"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldRegistrationDate"
                        class="col-12"
                        :form-context="formContext"
                        label="Erstzulassung"
                        property="registrationDate"
                        :subform-identifier="subformIdentifier"
                        type="datepicker"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

const FIELD_REFS = [
    'fieldVin',
    'fieldLicensePlate',
    'fieldModel',
    'fieldHsn',
    'fieldTsn',
    'fieldMileage',
    'fieldRegistrationDate',
];

export default {
    name: 'DataApplicationVehicleSubForm',
    mixins: [FormDataMixin],
    props: {
        formContext: {
            type: Object,
            required: true,
        },
    },
    emits: [
        'field-inclusion-changed',
        'field-hover-changed',
    ],
    data() {
        return {
            fieldInclusionStates: {},
            subformIdentifier: 'vehicle',
        }
    },
    computed: {
        someIncluded() {
            const values = Object.values(this.fieldInclusionStates);
            return values.length === 0 || values.some((v) => v);
        },
        subFormAvailable() {
            if (!this.subformIdentifier) {
                return false;
            }
            if (!Array.isArray(this.formContext.subformIdentifiers)) {
                return false;
            }
            return this.formContext.subformIdentifiers.indexOf(this.subformIdentifier) !== -1;
        },
    },
    methods: {
        onFieldInclusionChangedWithTracking(data) {
            this.$set(this.fieldInclusionStates, data.property, data.included);
            this.$emit('field-inclusion-changed', data);
        },
        toggleAll() {
            const target = !this.someIncluded;
            FIELD_REFS.forEach((refName) => {
                const ref = this.$refs[refName];
                if (ref) {
                    ref.setIncluded(target);
                }
            });
        },
    },
}
</script>
